export default __webpack_public_path__ + "static/media/Zukala's Reliquary.b4e32a96.jpg";